import { DATE_FORMAT } from "@/shared/common/constants";
import type { IDefaultDateFilter } from "@/shared/common/types";
import { formatDate } from "@/shared/helpers";
import { useMemo, useState } from "react";

interface Props<T> {
  dayCount?: number;
  defaultFilter?: T;
}

export const useFilters = <T extends IDefaultDateFilter>({
  dayCount = 31, defaultFilter
}: Props<T> = {}) => {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - dayCount);

  const defaultFilters = useMemo(() => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - dayCount);

    return {
      startDate: formatDate(start, DATE_FORMAT.YYYY_MM_DD),
      endDate: formatDate(end, DATE_FORMAT.YYYY_MM_DD),
      ...defaultFilter,
    } as T;
  }, [dayCount, defaultFilter]);


  const [filters, setFilters] = useState<T>(defaultFilters);

  return {
    filters,
    setFilters,
    defaultFilters,
  };
};
